// extracted by mini-css-extract-plugin
export default {"auftragCard":"auftragcustomerdetailcomponent_auftragCard__-7o4Z","bottomHinweisGrid":"auftragcustomerdetailcomponent_bottomHinweisGrid__wHWA7"};